import cn from 'classnames';
import styles from './SelectFilter.module.scss';
import { FilterSelectType, SelectFilterObjectType } from '@/types';
import { Checkbox } from '../Checkbox';

type SelectFilterProps = {
  className?: string;
  filter: FilterSelectType;
  onChange: (code: string, value: string) => void;
  values: SelectFilterObjectType;
};

export function SelectFilter({
  className,
  filter,
  onChange,
  values,
}: SelectFilterProps) {
  const wrapperClassName = cn(styles.wrapper, className);

  const handleChange = (value: string) => {
    onChange(filter.code, value);
  };

  const activeValues = values[filter.code]?.values || [];

  return (
    <div className={wrapperClassName}>
      {filter.values.map((item) => (
        <div key={item.value} className={styles.variant}>
          <Checkbox
            checked={activeValues.includes(item.urlId)}
            onChange={() => handleChange(item.urlId)}
          />
          <span
            className={styles.title}
            onClick={() => handleChange(item.urlId)}
          >
            {item.value}
          </span>
        </div>
      ))}
    </div>
  );
}
